"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _formik = require("formik");

var _excluded = ["id", "name", "question", "subQuestionInfo", "className", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CHUIDropDown = function CHUIDropDown(_ref) {
  var id = _ref.id,
      name = _ref.name,
      question = _ref.question,
      subQuestionInfo = _ref.subQuestionInfo,
      className = _ref.className,
      options = _ref.options,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useField = (0, _formik.useField)(name),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var _React$useState = _react.default.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var formik = (0, _formik.useFormikContext)();

  var configTextfield = _objectSpread(_objectSpread(_objectSpread({}, field), otherProps), {}, {
    fullWidth: true,
    variant: "outlined",
    type: "ShortTextfield"
  });

  if (meta && meta.error && meta.touched) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  var handleChange = function handleChange(event) {
    formik.setFieldValue(name, event.target.value);
    setValue(event.target.value);
  };

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 11
  }, question != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6",
    htmlFor: id,
    tabIndex: "0"
  }, question), subQuestionInfo != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    htmlFor: id,
    tabIndex: "0",
    sx: {
      fontSize: "18",
      fontWeight: "bold"
    }
  }, subQuestionInfo)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.Select, {
    id: id,
    value: value,
    onChange: handleChange
  }, options.map(function (option, i) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: i,
      value: option["value"]
    }, option["text"]);
  })))), formik.errors[name] ? /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true,
    sx: {
      color: "#f44336"
    }
  }, formik.errors[name]) : null);
};

var _default = CHUIDropDown;
exports.default = _default;